
  /* Sticky pinning via sentinel + scroll listener.

     The `[data-sticky-sentinel]` is a 0-height invisible element placed
     in document flow right above the bar. As the user scrolls, the
     sentinel moves up through the viewport. We read its position via
     getBoundingClientRect() — when its top crosses the header offset
     (134px desktop, 120px mobile, i.e., the bottom of the category-nav),
     we add `.product-sticky--pinned` to swap the bar to position: fixed.
     When the sentinel scrolls back DOWN past that threshold (user
     scrolling up), we remove the class and the bar returns to flow.

     Why a sentinel instead of reading the bar's own rect: the bar's
     position changes when it becomes fixed (top: 134px in viewport
     coords). The sentinel stays in flow regardless, giving a stable
     reference. This pattern is bulletproof against containing-block
     quirks that broke position: sticky in this theme. */
  (function () {
    var sentinel = document.querySelector('[data-sticky-sentinel]');
    var bar = document.querySelector('[data-product-sticky]');
    if (!sentinel || !bar) return;

    /* Cache the category-nav element once; we re-query its
       boundingClientRect each update to track its stuck position
       (which depends on the logo height set in section settings). */
    var categoryNav = document.querySelector('#shopify-section-category-nav');

    function getOffset() {
      /* When the category-nav is stuck at top, its rect.bottom IS the
         y-coordinate where we want the product sticky bar to pin —
         flush against its bottom edge. Reading rect dynamically means
         we adapt automatically to the merchant's logo size + any
         changes to the category-nav's height. Fallback to a fixed
         offset only if the category-nav element isn't on the page. */
      if (categoryNav) {
        var rect = categoryNav.getBoundingClientRect();
        return Math.max(0, rect.bottom);
      }
      return window.innerWidth <= 900 ? 120 : 134;
    }

    function updatePin() {
      var offset = getOffset();
      var rect = sentinel.getBoundingClientRect();
      var shouldPin = rect.top < offset;
      if (shouldPin) {
        /* Set inline top so the bar sits exactly at the category-nav's
           bottom edge, with no gap. Updates every scroll frame which is
           cheap (a single getBoundingClientRect + style set). */
        bar.style.top = offset + 'px';
        if (!bar.classList.contains('product-sticky--pinned')) {
          bar.classList.add('product-sticky--pinned');
        }
      } else {
        if (bar.classList.contains('product-sticky--pinned')) {
          bar.classList.remove('product-sticky--pinned');
          bar.style.top = '';
        }
      }
    }

    window.addEventListener('scroll', updatePin, { passive: true });
    window.addEventListener('resize', updatePin);

    /* Initial check + a couple of follow-ups after delays in case the
       page height shifts (UFE injecting ~500ms later, lazy-loaded
       images settling, etc.). */
    updatePin();
    setTimeout(updatePin, 200);
    setTimeout(updatePin, 800);
  })();
